import { useRecoilValue } from 'recoil'
import { editorPageSetTurnedOverSelector } from '@/atoms/editorTextBoxAtoms'

/**
 * Whether the open page set is turned over to Lotus text boxes: any of its
 * pages carries a turnover run id.
 */
export const useEditorPageSetTurnedOver = (): boolean =>
  useRecoilValue(editorPageSetTurnedOverSelector)
